import { Localized } from '../../internal/Localized';
import Styles from './Landing.module.css';
import { Label } from '@app/engine';

/** File-local constants for PainCard (decorative, non-translatable glyphs). */
const localConstants = {
  icon1: '📵',
  icon2: '⏱️',
  icon3: '💸',
  icon4: '🌙'
} as const;

/** Props for a single pain item. */
interface IPainItemProps {
  icon: string;
  title: string;
  desc: string;
}

/**
 * A single pain point (icon + title + description).
 *
 * @param props - Component props.
 * @returns The pain item element.
 */
function PainItem(props: IPainItemProps) {
  return (
    <div className={Styles.painItem}>
      {/* Raw <span>: decorative emoji icon flagged aria-hidden; engine Label cannot set aria-hidden and would add a glyph title tooltip. */}
      <span className={Styles.painIcon} aria-hidden="true">
        {props.icon}
      </span>
      <div className={Styles.painItemText}>
        <Label text={props.title} classNameContainer={Styles.painItemTitle} />
        <Label text={props.desc} classNameContainer={Styles.painItemDesc} />
      </div>
    </div>
  );
}

/**
 * Card 2 — the problem. Frames the cost of missed calls for trades owners.
 *
 * @returns The pain card element.
 */
export function PainCard() {
  return (
    <section className={`${Styles.cardInner} ${Styles.cardPain}`}>
      <div className={Styles.cardTag}>
        <Label text={Localized.LandingPainLabel} classNameContainer={Styles.sectionLabel} />
        {/* Structural wrapper: a single Label cannot render the two-line styled headline, so a div is used and each line carries the tooltip. */}
        <div className={Styles.sectionTitle}>
          <Label text={Localized.LandingPainTitle1} title={`${Localized.LandingPainTitle1} ${Localized.LandingPainTitle2}`} />
          <br />
          <Label text={Localized.LandingPainTitle2} title={`${Localized.LandingPainTitle1} ${Localized.LandingPainTitle2}`} classNameContainer={Styles.accent2} />
        </div>
      </div>
      <div className={Styles.cardBody}>
        <div className={Styles.painGrid}>
          <div className={Styles.painStatement}>
            <Label text={Localized.LandingPainStatement} />
          </div>
          <div className={Styles.painList}>
            <PainItem icon={localConstants.icon1} title={Localized.LandingPainItem1Title} desc={Localized.LandingPainItem1Desc} />
            <PainItem icon={localConstants.icon2} title={Localized.LandingPainItem2Title} desc={Localized.LandingPainItem2Desc} />
            <PainItem icon={localConstants.icon3} title={Localized.LandingPainItem3Title} desc={Localized.LandingPainItem3Desc} />
            <PainItem icon={localConstants.icon4} title={Localized.LandingPainItem4Title} desc={Localized.LandingPainItem4Desc} />
          </div>
        </div>
      </div>
    </section>
  );
}
